export default "__VITE_ASSET__CzOUmGjX__"